import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';

export default withStyles({
  root: {
    color: 'rgba(0,0,0,0.87)',
    textAlign: 'right',
  },
})(ListItemText);
